export const SIDE_NAV_WIDTH = 125;
